/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 * File Path: packages/common/types/User.ts
 */

import { z } from 'zod';

export type JobRoleId =
  | 'ceo'
  | 'sales'
  | 'project'
  | 'product'
  | 'eng'
  | 'research'
  | 'people'
  | 'marketing'
  | 'hr'
  | 'finance'
  | 'legal'
  | 'customer_success'
  | 'support'
  | 'design'
  | 'user'
  | 'other';
export type JobRolePlan = {
  id: JobRoleId;
  name: string;
  description: string;
  points: string[];
  badge?: string;
};

export type CommunicationStyleId =
  | 'direct'
  | 'detailed'
  | 'collaborative'
  | 'analytical'
  | 'creative';

export type UserProfile = {
  displayLanguage: string;
  selectedLanguages: string[];
  role: JobRoleId | null;
  roles: JobRoleId[];
  communicationStyles?: CommunicationStyleId[];
  currentOnboardingStepIndex?: number;
};

export const notificationsFormSchema = z.object({
  threads_digest: z.boolean().default(false).optional(),
  meeting_prep: z.boolean().default(false).optional(),
  product_updates: z.boolean().default(false).optional(),
  account_emails: z.boolean().default(true).optional(),
  push_notifications: z.boolean().default(false).optional()
});

export type Notifications = z.infer<typeof notificationsFormSchema>;

export type User = {
  id: string;
  createdAt: string;
  deletedAt: string;
  email: string;
  firstName: string;
  lastName: string;
  picture?: string;
  profile: UserProfile;
  notifications: Notifications;
};

export type UserAuth = {
  idToken: string | null;
  refreshToken: string | null;
  apiToken: string | null;
  apiTokenM: string | null;

  // Metadata for offline boot
  /** Unix timestamp (milliseconds) when tokens were issued */
  issuedAt?: number;
  /** Unix timestamp (milliseconds) when idToken expires */
  expiresAt?: number;
  /** Unix timestamp (milliseconds) of last successful server validation */
  lastValidated?: number;
};
